import { connect } from 'react-redux';
import _ from 'lodash';
import { getScreenData, Store, showDialog, setScreenData, removeScreenData } from 'cw-ui-core';
import EditExternalIdP from 'src/features/authentication-v2/components/EditExternalIdP/EditExternalIdP';
import { toMap, toArray } from 'src/util/Util';
import {
    loadLoginProviderWithUsers,
    updateExternalIdP,
    updateAssignedUsersForAuthProvider,
} from 'src/services/LoginProviderService';
import { AUTH_PROVIDER_EDIT_ASSIGNED_USERS_DIALOG, EDIT_EXTERNAL_IDP } from 'src/features/authentication-v2/constants';
import { clearAlertMessages } from 'src/features/authentication-v2/components/utils';

const mapStateToProps = state => {
    const screenKey = EDIT_EXTERNAL_IDP;

    const identityProviderData = toMap(getScreenData(state.screen, ['identityProvider'], screenKey));
    const initialIdentityProviderData = toMap(getScreenData(state.screen, ['initialIdentityProviderData'], screenKey));
    const formErrors = toMap(getScreenData(Store().getState().screen, ['formErrors'], screenKey));

    const currentlySelectedUsers = toArray(getScreenData(Store().getState().screen, ['selectedUsers'], screenKey));
    const initiallySelectedUsers = toArray(
        getScreenData(Store().getState().screen, ['initiallySelectedUsers'], screenKey)
    );

    const usersSelectionUpdated = !_.isEqual(currentlySelectedUsers, initiallySelectedUsers);
    const isError = _.some(formErrors, val => !_.isEmpty(val));
    const updatedClientSecretData = getScreenData(state.screen, ['clientSecrets'], screenKey);

    return {
        identityProviderData,
        initialIdentityProviderData,
        usersSelectionUpdated,
        isError,
        screenKey,
        updatedClientSecretData,
    };
};

const mapDispatchToProps = dispatch => {
    const screenKey = EDIT_EXTERNAL_IDP;

    return {
        onComponentDidMount: () => {
            clearAlertMessages(screenKey);
        },
        loadLoginProviderWithUsers: scheme => {
            Store().runSaga(loadLoginProviderWithUsers, scheme, screenKey);
        },
        updateLoginProvider: () => {
            const identityProvider = getScreenData(Store().getState().screen, ['identityProvider'], screenKey).toJS();
            Store().runSaga(updateExternalIdP, identityProvider, screenKey);
        },
        updateLoginProviderAssignedUsers: () => {
            const scheme = getScreenData(Store().getState().screen, ['identityProvider', 'scheme'], screenKey);

            const currentlySelectedUsers = toArray(
                getScreenData(Store().getState().screen, ['selectedUsers'], screenKey)
            );

            const initiallySelectedUsers = toArray(
                getScreenData(Store().getState().screen, ['initiallySelectedUsers'], screenKey)
            );

            const usersToAdd = _.difference(currentlySelectedUsers, initiallySelectedUsers);
            const usersToRemove = _.difference(initiallySelectedUsers, currentlySelectedUsers);

            if (!_.isEmpty(usersToRemove)) {
                dispatch(
                    showDialog(AUTH_PROVIDER_EDIT_ASSIGNED_USERS_DIALOG, {
                        usersToAdd,
                        usersToRemove,
                    })
                );
            } else {
                const usersOptions = {
                    addUsers: usersToAdd,
                    removeUsers: [],
                    currentlySelectedUsers,
                };

                Store().runSaga(updateAssignedUsersForAuthProvider, scheme, usersOptions, screenKey);
            }
        },
        onComponentWillUnmount: () => {
            dispatch(setScreenData('selectedUsers', [], screenKey));
            dispatch(setScreenData('initiallySelectedUsers', [], screenKey));
            dispatch(removeScreenData(['identityProvider'], screenKey));
            dispatch(removeScreenData(['identityProviderExtraFields'], screenKey));
            dispatch(removeScreenData(['fieldsValidity'], screenKey));
            dispatch(removeScreenData(['errors'], screenKey));
            dispatch(removeScreenData(['formErrors'], screenKey));
            dispatch(removeScreenData(['isValidAuthorityUrl'], screenKey));
        },
    };
};

const EditExternalIdPContainer = connect(mapStateToProps, mapDispatchToProps)(EditExternalIdP);

export default EditExternalIdPContainer;
